import { ToggleGroup, Options, Menu } from '@instructure/ui';
import {
  Badge,
  Tag,
  Flex,
  View,
  IconExternalLinkLine,
  IconButton,
  IconSettingsLine,
  IconNoLine,
  Text,
} from '@smarterservices/smarter-ui';
import useAppStore from '../../stores/app';
import useSessionStore from '../../stores/session';

const AwaitingCheckin = () => {
  const { openDrawer } = useAppStore();
  const { waiting, setTransferSessionSid, setEndSessionSid } =
    useSessionStore();

  const renderOptionsMenu = (sessionSid) => {
    return (
      <Menu
        placement="bottom end"
        shouldContainFocus
        shouldReturnFocus
        mountNode={() => document.body} // Ensures the menu overlays everything
        trigger={
          <IconButton
            withBackground={false}
            withBorder={false}
            color="primary"
            size="small"
            screenReaderLabel="Session Options"
            margin="none"
            padding="none"
          >
            <IconSettingsLine />
          </IconButton>
        }
      >
        <Menu.Item onSelect={() => openDrawer('focus', sessionSid)}>
          <Flex alignItems="center">
            <Flex.Item margin="0 xx-small 0 0">
              <IconExternalLinkLine size="x-small" />
            </Flex.Item>
            <Flex.Item>
              <Text>Start Check-in</Text>
            </Flex.Item>
          </Flex>
        </Menu.Item>
        <Menu.Separator />
        <Menu.Item onSelect={() => setTransferSessionSid(sessionSid)}>
          <Flex alignItems="center">
            <Flex.Item margin="0 xx-small 0 0">
              <IconExternalLinkLine size="x-small" />
            </Flex.Item>
            <Flex.Item>
              <Text>Transfer</Text>
            </Flex.Item>
          </Flex>
        </Menu.Item>
      </Menu>
    );
  };

  return (
    <>
      <ToggleGroup
        toggleLabel="This is the toggle button label for screenreaders"
        summary={
          <Flex justifyItems="space-between" margin="none small none none">
            <Flex.Item>Awaiting Check-in</Flex.Item>

            {Object.keys(waiting).length && (
              <Flex.Item>
                <Badge
                  count={Object.keys(waiting).length}
                  variant="danger"
                  pulse={true}
                  standalone
                />
              </Flex.Item>
            )}
          </Flex>
        }
        defaultExpanded
      >
        {Object.keys(waiting).length ? (
          <Options>
            {Object.entries(waiting).map(([sessionSid, data]) => (
              <Options.Item
                key={`session_waiting_${sessionSid}`}
                //renderAfterLabel={renderOptionsMenu(sessionSid)}
                beforeLabelContentVAlign="start"
                afterLabelContentVAlign="start"
              >
                <Flex justifyItems="space-between" padding="none">
                  <Flex.Item width="3.2rem">
                    <Tag size="small" text="2:21" />
                  </Flex.Item>
                  <Flex.Item textAlign="start" shouldGrow>
                    {data.firstName} {data.lastName}
                  </Flex.Item>
                  <Flex.Item width="2rem" textAlign="end">
                    {renderOptionsMenu(sessionSid)}
                  </Flex.Item>
                </Flex>
              </Options.Item>
            ))}
          </Options>
        ) : (
          <View as="div" padding="small" textAlign="center">
            <Text>No sessions waiting</Text>
          </View>
        )}
      </ToggleGroup>
    </>
  );
};

export default AwaitingCheckin;
